'use client';

import {
  useProductAdditionalInforms,
  useSalePageQuery,
} from '@/entities/salePage';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import dynamic from 'next/dynamic';
import { PurchaseCTAButtonProps } from './PurchaseCTAButton';

const PurchaseCTAButton = dynamic(
  () => import('./PurchaseCTAButton').then(mod => mod.PurchaseCTAButton),
  {
    ssr: false,
  }
);

interface PurchaseCTAButtonFetcherProps extends PurchaseCTAButtonProps {
  salePageId: number;
}

export const PurchaseCTAButtonFetcher = ({
  salePageId,
}: PurchaseCTAButtonFetcherProps) => {
  const device = useDeviceSize();
  const salePageQuery = useSalePageQuery(salePageId);
  const salePageType = salePageQuery.data?.type;

  const shouldFetchAdditionalInforms =
    salePageType === undefined ? false : salePageType !== 'CLASS';

  const productAdditionalInformsQuery = useProductAdditionalInforms(
    salePageId,
    {
      enabled: shouldFetchAdditionalInforms,
    }
  );

  if (device !== 'mobile') return null;

  const salePage = salePageQuery.data;
  const productAdditionalInforms = productAdditionalInformsQuery.data;

  return (
    <PurchaseCTAButton
      salePage={salePage}
      productAdditionalInforms={productAdditionalInforms}
    />
  );
};
